// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"b46d0553","356":"b46d0553","442":"fbc51bee"}[chunkId] + ".css";
};